import request from "./base";
const path = "/api/workers";

export default {
  get: function (params) {
    return request().get(path + "/", {
      params: params
    });
  },
  setGroup: function({worker_uids, group}) {
    return request().patch(path + "/groups", {
      worker_uids, group
    });
  },
  addGroup: function(group) {
    return request().post(path + "/groups", {
      group
    });
  },
  getIpList: function() {
    return request().get(path + "/ips");
  },
  getGroupList: function() {
    return request().get(path + "/groups");
  },
  disconnect: function({worker_uids}) {
    return request().delete(path + "/", {
      data: {worker_uids}
    });
  },
  reload: function({worker_uids}) {
    return request().post(path + "/reload", {worker_uids});
  },
  openWindow: function({worker_uids}) {
    return request().post(path + "/windows/open", {worker_uids});
  },
  closeWindow: function({worker_uids}) {
    return request().post(path + "/windows/close", {worker_uids});
  }
};
